<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1271px' }">
      <v-layout row wrap>
        <v-flex xs12 md12 lg12>
          <h2 class="mt-4 title mb-2">
            Fractional account values for markets with same quote currency
            <v-icon
              @click="
                infoAlert(
                  $t('dashboard.fractional_account_value_title'),
                  $t('dashboard.fractional_account_value_text')
                )
              "
              >fa-info-circle</v-icon
            >
          </h2>
          <div v-if="Object.keys(this.managedValueHistory).length > 0">
            <v-layout row wrap class="mb-3">
              <v-flex
                v-for="(exchangeData, coin) of managedValueHistory"
                :key="coin"
                xs12
                md6
                lg6
              >
                <ChartWrapper
                  :title="coin"
                  :subtitle="true"
                  :data="exchangeData"
                  :coin="coin"
                ></ChartWrapper>
              </v-flex>
            </v-layout>
          </div>
          <v-card v-else class="card-bordered">
            <v-card-text class="text-xs-center">
              <h3>No data for display</h3>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.theme--light .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
  color: #103a84;
}
.theme--light .card-bordered {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
  color: #103a84;
}
.theme--dark .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
}
.theme--dark .card-bordered {
  background: #212121;
  box-shadow: none !important;
  border-radius: 15px;
  color: #e9e9e9;
}
</style>

<script>
import { mapGetters } from "vuex";
import ChartWrapper from "../components/dashboard/ChartWrapper";
import swal from "sweetalert2";

export default {
  components: {
    ChartWrapper
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode",
      managedValueHistory: "accountValue/managed_value_history"
    }),
    isMobile: function() {
      return this.windowWidth < 769;
    }
  },
  mounted: function() {
    this.$store.dispatch("accountValue/fetchAccountValue");
  },
  methods: {
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/performance.vue